import { useEffect } from 'react';
import { identityStore } from '../store/store';
import { guardedMeRequest } from '../api/me';
import { refreshRequest } from '../api/refresh';

const TOKEN_CHECK_INTERVAL = 60_000;
const TOKEN_REFRESH_THRESHOLD = 60;

export function useTokenRefreshBehaviour() {
  useEffect(() => {
    const interval = setInterval(async () => {
      const { user, update, logout } = identityStore.getState();
      if (!user) return;

      const now = Math.floor(Date.now() / 1000);
      if (user.exp - now >= TOKEN_REFRESH_THRESHOLD) return;

      try {
        await refreshRequest();
        update({ user: await guardedMeRequest() });
      } catch {
        await logout();
      }
    }, TOKEN_CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);
}
